import '@expo/metro-runtime';
import React, { lazy, Suspense } from 'react';
import { usePreventPageZoom } from 'src/hooks/usePreventPageZoom';
import { TRouteComponent } from './_shared/routes.types';
import { PageLoader } from '@photosi/rn-components/page-loader/PageLoader';

const EditApp = lazy(() => import('src/screen/editor-v3/Edit'));

export const EditRoute: TRouteComponent = () => {
  usePreventPageZoom();

  return (
    <Suspense fallback={<PageLoader />}>
      <EditApp />
    </Suspense>
  );
};
